// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFoundPage_container__2x_13","header":"NotFoundPage_header__1OJQU","text":"NotFoundPage_text__QglWK","code":"NotFoundPage_code__1OfLp"};